const filterQueryParams = <T extends Record<string, unknown>>(
  allQueryParams: Record<string, unknown>,
  validQueryParams: (keyof T)[]
): Partial<T> => {
  const entries = Object.entries(allQueryParams).filter(
    ([key, value]) => value !== undefined && validQueryParams.includes(key as keyof T)
  );

  return Object.fromEntries(entries) as Partial<T>;
};

export default filterQueryParams;
